const state = {
    cachedRoutes: ['HomeView', 'IntelligentJudgment'], //需要缓存的路由
    transitionName: 'slide-left', //路由动画名称
    cachedRoutesHistory: [
        {
            path: '/home',
            historyIndex: 0
        }         /*首页默认为路由历史的第一页*/
    ], //路由缓存历史,决定路由加载的动画
    historyIndex: 0
}

const mutations = {
    updateTransitionName(state, pathObject) {
        /*通过路由的to和from来决定路由的动画,如果是前进动画为左滑，后退为右滑*/
        const toPath = state.cachedRoutesHistory.find(history => history.path === pathObject.to);
        const fromPath = state.cachedRoutesHistory.find(history => history.path === pathObject.from);
        if (toPath && fromPath) {
            const toIndex = toPath.historyIndex;
            const fromIndex = fromPath.historyIndex;
            if (toIndex < fromIndex) {
                state.transitionName = 'slide-right';
                const index = state.cachedRoutesHistory.findIndex(history => history.path === toPath.path);
                state.cachedRoutesHistory.splice(index);
            } else {
                state.transitionName = 'slide-left';
            }
        } else {
            state.transitionName = 'slide-left';
        }

        state.historyIndex++;
        state.cachedRoutesHistory.push({
            path: pathObject.to,
            historyIndex: state.historyIndex
        });
    },
    /*添加路由缓存历史*/
    addCachedRoutesHistory(state, routerPath) {
        if (!state.cachedRoutesHistory.includes(routerPath)) {
            state.cachedRoutesHistory.push(routerPath);
        }
    },
    /*删除路由缓存历史*/
    deleteCachedRoutesHistory(state, routerPath) {
        state.cachedRoutesHistory = state.cachedRoutesHistory.filter(history => history !== routerPath);
    },
    /*添加需要缓存的路由*/
    addCachedRoutes(state, addedRouteName) {
        if (!state.cachedRoutes.includes(addedRouteName)) {
            state.cachedRoutes.push(addedRouteName);
        }
    },
    /*删除需要缓存的路由*/
    deleteCachedRoutes(state, clearedRouteName) {
        state.cachedRoutes = state.cachedRoutes.filter(item => item != clearedRouteName);
    }
}

const actions = {
    updateTransitionName({commit}, pathObject) {
        commit("updateTransitionName", pathObject);
    },
    addCachedRoutesHistory({commit}, routerPath) {
        commit("addCachedRoutesHistory", routerPath);
    },
    deleteCachedRoutesHistory({commit}, routerPath) {
        commit("deleteCachedRoutesHistory", routerPath);
    },
    addCachedRoutes({commit}, addedRouteName) {
        commit("addCachedRoutes", addedRouteName);
    },
    deleteCachedRoutes({commit}, clearedRouteName) {
        commit("deleteCachedRoutes", clearedRouteName);
    },
}

const getters = {
    transitionName: state => state.transitionName,
    cachedRoutes: state => state.cachedRoutes,
    cachedRoutesHistory: state => state.cachedRoutesHistory
}

export default {
    state,
    getters,
    mutations,
    actions,
    // store的模块名
    module: "app-theme",
    // 是否设置命名空间
    namespaced: true
}

